import { createSlice } from '@reduxjs/toolkit';
import {
  addPresent,
  changePresent,
  changeStatus,
  fetchPresents,
} from './operations';
const initialState = {
  items: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
  },
};

export const slicePresents = createSlice({
  name: 'Presents',
  initialState,
  reducers: {
    reducer1(state, { payload: userData }) {},
    reducer2(state, { payload: userData }) {},
    reducer3(state, { payload: userData }) {},
    reducer4: {
      reducer(state, { payload: userData }) {},
      prepare(userData) {},
    },
  },

  extraReducers: builder => {
    builder
      .addCase(fetchPresents.fulfilled, (state, { payload: userData }) => {
        const { presents, ...paginationData } = userData;
        state.items = presents;
        state.pagination = paginationData;
      })

      .addCase(addPresent.fulfilled, (state, { payload: item }) => {
        // state.items.push(item);
      })
      .addCase(changePresent.fulfilled, (state, { payload: userData }) => {
        const index = state.items.findIndex(el => el._id === userData._id);
        if (index >= 0) {
          state.items[index] = userData;
        }
      })
      .addCase(changeStatus.fulfilled, (state, { payload: userData }) => {
        const index = state.items.findIndex(el => el._id === userData._id);
        if (index >= 0) {
          state.items[index] = userData;
        }
      });
  },
});

export const { reducer1, reducer2, reducer3 } = slicePresents.actions;
export default slicePresents.reducer;
